exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remover {\r\n  color: crimson;\r\n}\r\n\r\n.remover:hover {\r\n  font-size: 1.3em;\r\n  color: black;\r\n  cursor: default;\r\n}\r\n\r\nform {\r\n  margin-top: 2em;\r\n}\r\n\r\nh3 {\r\n  margin-top: 1em;\r\n  right: auto;\r\n  left: auto;\r\n  text-align: center;\r\n  -ms-user-select: none;\r\n      user-select: none;\r\n  -moz-user-select: none;\r\n  -webkit-user-select: none;\r\n  cursor: default;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/usuario/cadastro-usuario/cadastro-usuario.component.css
// module id = ../../../../../src/app/usuario/cadastro-usuario/cadastro-usuario.component.css
// module chunks = main